

























































import { LinkModel } from "@/assets/contents/ProjectContent";
import Vue from "vue";

export default Vue.extend({
    name: "PhotoTextBlock",
    components: {
    },
    props: {
        title: {
            type: String,
            required: false,
            default: "This is title",
        },
        role: {
            type: String,
            required: false,
            default: "This is role",
        },
        descriptions: {
            type: Array,
            required: false,
            default: (): string[] => [
                "AAAAAAAAAAAAAAAAAA",
                "BBBBBBBBBBBBBBBBBB",
                "CCCCCCCCCCCCCCCCCC",
            ],
        },
        startDate: {
            type: String,
            required: false,
            default: "",
        },
        endDate: {
            type: String,
            required: false,
            default: "",
        },
        photo: {
            type: String,
            required: true,
        },
        links: {
            type: Array as () => Array<LinkModel>,
            required: false,
            default: (): LinkModel[] => [],
        },
        tags: {
            type: Array as () => Array<string>,
            required: false,
            default: (): string[] => [],
        },
        hideBullet: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
        };
    },
    computed: {
        startToEndDateText(): string {
            if (this.startDate === "") {
                return "";
            }
            if (this.endDate === "") {
                return `${this.startDate} - Present`;
            }
            if (this.startDate === this.endDate) {
                return this.startDate;
            }
            return `${this.startDate} - ${this.endDate}`;
        },
        mainLink(): string {
            if (this.links.length > 0) return this.links[0].url;
            return "#";
        },
    },
});
